import * as React from 'react';
import locales from '../locales';
import {InvoiceLink} from '../api/dtos/dtos';
import * as paths from "../paths";
import {Link} from "react-router-dom";
import {renderInvoiceTypeSpan} from "./invoice";
import {Button, Popover} from 'antd';
import {showConfirm} from '../utils/dialogs';
import accountProvider from '../account/AccountProvider';

interface Props {
  finalized: boolean;
  invoice?: InvoiceLink | null;
  onRevertFinalized?: () => void;
}

class InvoiceCell extends React.Component<Props, { popoverVisible: boolean }> {
  public state = {popoverVisible: false};

  public render(): React.ReactNode {
    const {finalized, invoice} = this.props;

    if (finalized && (invoice == null || invoice.type === 'STORNO')) {
      return this.props.onRevertFinalized ? (
        <Popover
          trigger="click"
          visible={this.state.popoverVisible}
          onVisibleChange={this.changePopoverVisible}
          content={<Button onClick={this.onReopenClick}>{locales.reopen}</Button>}
        >
          <Button type="link" style={{padding: 0, height: 'auto'}}>{locales.finalized}</Button>
        </Popover>
      ) : locales.finalized;
    }

    if (invoice == null) {
      return '-';
    }

    return (
      <div>
        {renderInvoiceTypeSpan(invoice.type)} {accountProvider.isAdmin() ? (
        <Link to={paths.viewInvoicePath(invoice.id)} style={{textDecoration: 'none'}}>{invoice.displayNumber}</Link>
      ) : invoice.displayNumber}
      </div>
    );
  }

  private changePopoverVisible = (visible: boolean) => {
    this.setState({popoverVisible: visible});
  }

  private onReopenClick = () => {
    this.setState({popoverVisible: false});
    const {onRevertFinalized} = this.props;
    if (onRevertFinalized) {
      showConfirm(locales.revert_finalize_confirm, onRevertFinalized);
    }
  };
}

export default InvoiceCell;



// WEBPACK FOOTER //
// ./src/invoicing/InvoiceCell.tsx